/* Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. */

import {
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
  SimpleChanges, OnChanges,
} from '@angular/core';
import {
  IconSettings,
  Icon,
  IconSize,
  IconSettingsType,
} from '../../../common/iconSettings';

@Component({
  selector: 'xrx-icon-picker',
  templateUrl: './xrx-icon-picker.component.html',
  styleUrls: ['./xrx-icon-picker.component.less'],
  standalone: false,
})
export class XrxIconPickerComponent implements OnInit, OnChanges {
  @Input() isMfd: boolean;
  @Input() icon: Icon;
  @Input() showDefault: boolean;
  @Input() iconSize: IconSize = IconSize.Large;
  @Input() set originalIcon(value: Icon) {
    this._originalIcon = value;
  }
  get originalIcon(): Icon | null {
    return this._originalIcon;
  }

  @Output() iconChange = new EventEmitter<Icon>();
  @Output() originalIconChange = new EventEmitter<Icon>();
  @Output() showDefaultChange = new EventEmitter<boolean>();
  @Output() iconSizeChange = new EventEmitter<IconSize>();

  private _originalIcon: Icon;
  iconSettings: IconSettingsType;
  xs = 575;
  iconList: string[][];
  colorList: string[][];

  constructor() {}

  ngOnInit(): void {
    if (!this.originalIcon) {
      this.originalIcon = this.icon;
    }
    this.iconSettings = IconSettings;
    this.iconSettings.selected = this.icon.glyph
      ? this.icon
      : IconSettings.getDefault();
    this.icon = this.iconSettings.selected;
    this.iconChange.emit(this.icon);

    // split the icon array
    this.iconList = this.splitArray(this.iconSettings.glyphs.options, 5);

    // split the color array
    this.colorList = this.splitArray(this.iconSettings.colors.options, 5);
  }

  ngOnChanges(changes: SimpleChanges) {
    // monitor icon property change to update the selected icon
    if (changes['icon'] && changes['icon'].firstChange === false) {
      this.iconSettings.selected = this.icon.glyph
        ? this.icon
        : IconSettings.getDefault();
    }
  }

  select(option: string, isColor = false) {
    if (isColor && this.iconSettings.selected) {
      this.iconSettings.selected.color = option;
      this.icon.color = option;
    } else if (this.iconSettings.selected) {
      this.iconSettings.selected.glyph = option;
      this.icon.glyph = option;
      this.icon.image = '';
    }
    this.iconChange.emit(this.icon);
  }

  splitArray(inputArray: string[], chunkSize = 5) {
    // split the inputArray into smaller chunks based on chunkSize
    const result = inputArray.reduce((resultArray: string[][], item, index) => {
      const chunkIndex = Math.floor(index / chunkSize);

      if (!resultArray[chunkIndex]) {
        resultArray[chunkIndex] = []; // start a new chunk
      }

      // push new chuck to resultArray
      resultArray[chunkIndex].push(item);

      return resultArray;
    }, []);

    return result;
  }
}
